module.exports = __webpack_public_path__ + "img/applicationresults_ry.534425c2.jpg";